export default __webpack_public_path__ + "static/media/CLOUDPROV_Dashboard.369f09e4.svg";